import axios from 'axios'

// 初始化DeepPay在线支付（Jana VPA）
const initOnlinePayment = data =>
  axios.post('/api/v1/pay/init-online-pay', data).then(res => res.data)

// 初始化SveltPay在线支付（NSDL）
const initSveltPayment = orderNum =>
  axios.post('/api/v1/sveltpay/init', { order_num: orderNum }).then(res => res.data)

export { initOnlinePayment, initSveltPayment }
